import {
  // Dashboard get All projects
  DEFAULT_LOGO_SUCCESS,
  PROJECTS_REQUEST,
  PROJECTS_SUCCESS,
  PROJECTS_FAIL,
  // Project Rename
  RENAME_PROJECT_REQUEST,
  RENAME_PROJECT_SUCCESS,
  RENAME_PROJECT_FAIL,
  // Template
  TEMPLATE_REQUEST,
  TEMPLATE_SUCCESS,
  TEMPLATE_FAIL,
  // Project Layout (Navbar / Sidebar / Preview / Options / Footer)
  PROJECT_REQUEST,
  PROJECT_SUCCESS,
  PROJECT_FAIL,
  PROJECT_CREATE_REQUEST,
  PROJECT_CREATE_SUCCESS,
  PROJECT_CREATE_FAIL,
  PROJECT_UPDATE_REQUEST,
  PROJECT_UPDATE_SUCCESS,
  PROJECT_UPDATE_FAIL,
  PROJECT_DELETE_REQUEST,
  PROJECT_DELETE_SUCCESS,
  PROJECT_DELETE_FAIL,
  // Crdit Reload Action
  PROJECT_CREDITS_UPDATE_REQUEST,
  PROJECT_CREDITS_UPDATE_SUCCESS,
  PROJECT_CREDITS_UPDATE_FAIL,
  PROJECT_CREDIT_OPTIONS_STATE_UPDATE,
  PROJECT_CREDITS_ITEMS_UPDATE_SUCCESS,
  CURRENT_BLOCK_UPDATE,
  UNDO_REDO_SET_STATE,
  FONT_UNDO_REDO_SET_STATE,
  SCREEN_UNDO_REDO_SET_STATE,

  // UploadLogo in Block
  PROJECT_LOGO_UPLOAD_SUCCESS,

  // Sidebar block move
  BLOCK_MOVE,
  // Setting Options
  OPTION_REQUEST,
  PROJECT_OPTION_SUCCESS,
  SETTING_OPTION_STATE,
  PROJECT_SETTINGS_UPDATE_SUCCESS,
  // FontStyles
  FONT_STYLE_UPDATE,
  FONT_STYLE_HISTORY_APPLY,
  PROJECT_FONTSTYLE_UPDATE_SUCCESS,
  // Render Export
  PROJECT_RENDER_REQUEST_SUCCESS,
  RENDER_DELETE_FAIL,
  RENDER_DELETE_SUCCESS,
  RENDER_DELETE_All_SUCCESS,
  RENDER_DELETE_ALL_FAIL,
  DOWNLOAD_RENDER_REQUEST,
  CARD_PROJECT_SUCCESS,
  CARD_PROJECT_FAIL,
  PROJECT_GLOBAL_OPTION_SUCCESS,
  USER_STRIPE_DATA_SUCCESS,
  USER_STRIPE_DATA_FAIL,
  HELP_PAGE_FAIL,
  PROJECT_SCROLL_GLOBAL_OPTION_SUCCESS,
  CUSTOM_FONTS_LOAD_SUCCESS,
} from "./types";
import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
} from "../../services/axios";
import store from "../store";
import UndoRedo from "../../UndoRedoClass";
import { toast } from "react-toastify";
import CustomToast, { customToatStyle } from "../../Components/CustomToast/CustomToast";
import {
  flushPendingProjectSaves,
  runProjectSave,
  scheduleProjectSave,
} from "../../Pages/ProjectV2/projectSaveCoordinator";
import {
  getUploadedLogo,
  mergeUploadedLogo,
} from "./logoLibraryUtils";
import { requireSuccessfulResponse } from "../../services/responseUtils";

const cloneProjectValue = (value) =>
  value == null ? value : JSON.parse(JSON.stringify(value));

const cardScreenDefaults = {
  screen_duration: 0,
  transition_in: "",
  transition_in_duration: 0,
  transition_out: "",
  transition_out_duration: 0,
  delay: 0,
};

const getCardScreenSnapshot = (options = {}) =>
  Object.keys(cardScreenDefaults).reduce(
    (snapshot, key) => ({
      ...snapshot,
      [key]: options[key] ?? cardScreenDefaults[key],
    }),
    {},
  );

const createCardScreenHistories = (credits = []) =>
  credits.map((credit, index) => {
    const obj = new UndoRedo();
    obj.push(getCardScreenSnapshot(credit.options));
    return { obj, index, creditsId: credit._id };
  });

const creditsSyncStorageKey = (projectId) =>
  `scrollx:last-credits-sync:${projectId}`;

const getRememberedCreditsSyncTime = (projectId) => {
  if (!projectId || typeof localStorage === "undefined") return null;
  return localStorage.getItem(creditsSyncStorageKey(projectId));
};

const rememberCreditsSyncTime = (projectId, value) => {
  if (!projectId || !value || typeof localStorage === "undefined") return;
  localStorage.setItem(creditsSyncStorageKey(projectId), value);
};

const createTypographyHistory = (fontStyle) => {
  const obj = new UndoRedo();
  obj.push(fontStyle);
  return { obj };
};

const layoutTypographyProperties = {
  rolename: {
    role: ["lineHeight", "marginBottom"],
    name: ["lineHeight", "marginBottom"],
  },
  nameonly: { nameOnlyStyle: ["lineHeight"] },
  song: {
    songTitle: ["lineHeight"],
    songDetails: ["lineHeight"],
  },
  blurb: { blurb: ["lineHeight"] },
};

const layoutTypographyDefaults = {
  lineHeight: 1,
  marginBottom: 0,
};

const getLayoutTypographySnapshot = (blockType, fontStyle = {}) => {
  const properties = layoutTypographyProperties[blockType?.toLowerCase()] || {};

  return Object.entries(properties).reduce((snapshot, [styleKey, keys]) => {
    snapshot[styleKey] = keys.reduce((style, property) => {
      style[property] =
        fontStyle?.[styleKey]?.[property] ??
        layoutTypographyDefaults[property];
      return style;
    }, {});
    return snapshot;
  }, {});
};

const mergeLayoutTypographySnapshot = (fontStyle, snapshot) => {
  const nextFontStyle = cloneProjectValue(fontStyle || {});
  Object.entries(snapshot || {}).forEach(([styleKey, properties]) => {
    nextFontStyle[styleKey] = {
      ...(nextFontStyle[styleKey] || {}),
      ...cloneProjectValue(properties),
    };
  });
  return nextFontStyle;
};

const rebaseTypographyHistory = (dispatch, snapshot) => {
  const historyState = store.getState().fontUndoRedo;
  const stack = historyState?.obj;
  if (!stack?.rewriteSnapshots) return;

  stack.rewriteSnapshots((fontStyle) =>
    mergeLayoutTypographySnapshot(fontStyle, snapshot),
  );
  dispatch({
    type: FONT_UNDO_REDO_SET_STATE,
    payload: { ...historyState },
  });
};

const createLayoutHistories = (credits = [], fontStyle = {}) => {
  const fontHistoriesByBlockType = {};
  return credits.map((credit, index) => {
    const obj = new UndoRedo();
    obj.push(credit.options);
    const blockType = credit.options?.block_type?.toLowerCase();
    if (!fontHistoriesByBlockType[blockType]) {
      fontHistoriesByBlockType[blockType] = new UndoRedo();
      fontHistoriesByBlockType[blockType].push(
        getLayoutTypographySnapshot(blockType, fontStyle),
      );
    }
    const layoutFontObj = fontHistoriesByBlockType[blockType];
    return { obj, layoutFontObj, index, creditsId: credit._id };
  });
};

const returnToastNotify = async (key, value) => {
  if (key === "double_columns" && (value || !value)) {
    const column =
      key === "double_columns" && value
        ? "Double Column Set"
        : key === "double_columns" && !value
          ? "Single Column Set"
          : "";
    return toast.success("saving...", { autoClose: 300 });
  } else if (key === "name_on_left" && (value || !value)) {
    const name =
      key === "name_on_left" && value
        ? "Name Set On Left"
        : key === "name_on_left" && !value
          ? "Name Set On Right"
          : "";
    return toast.success("saving...", { autoClose: 300 });
  } else if (
    key === "block_inset" &&
    (value === "default" ||
      value === "left" ||
      value === "right" ||
      value === "sidebyside")
  ) {
    const blockInset = `Block Inset Set ${value}`;
    return toast.success("saving...");
  } else if (key === "margin_vertical") {
    const margin = `Vertical Margin Set ${value} %`;
    return toast.success("saving...", { autoClose: 300 });
  }
};

// Create project
export const createProject = (data) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_CREATE_REQUEST });
    const { data: projectData } = await postRequest(`/project/`, data);
    const { project } = projectData;
    dispatch({
      type: PROJECT_CREATE_SUCCESS,
      payload: {
        project,
      },
    });
  } catch (error) {
    dispatch({
      type: PROJECT_CREATE_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

// Create project By Google
export const createAGoogleProject =
  (projectName, templateId) => async (dispatch) => {
    try {
      dispatch({ type: PROJECT_CREATE_REQUEST });
      const projectRoute =
        process.env.REACT_APP_PROJECT_CREATE_ROUTE || "byGoogle";
      const projectData = await postRequest(`/project/${projectRoute}`, {
        // title: `Google Project ${new Date().toDateString()}${Date.now()}`, //Will update it by user entered value
        title: projectName,
        templateId: templateId ? templateId : 0,
      });
      const { project } = projectData?.data || {};
      if (project) {
        dispatch({
          type: PROJECT_CREATE_SUCCESS,
          payload: {
            project,
          },
        });
        return projectData?.data;
      } else {
        return projectData?.response?.data || projectData?.data;
      }
    } catch (error) {
      dispatch({
        type: PROJECT_CREATE_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
      return error;
    }
  };

export const createCardProject =
  (projectName, templateId, resolution) => async (dispatch) => {
    try {
      dispatch({ type: PROJECT_CREATE_REQUEST });
      const projectRoute =
        process.env.REACT_APP_PROJECT_CREATE_ROUTE || "byGoogle";
      const projectData = await postRequest(`/project/createACardProject`, {
        title: projectName,
        resolution: resolution,
        templateId: templateId ? templateId : 0,
      });
      const { cardProject } = projectData?.data || {};
      if (cardProject) {
        dispatch({
          type: CARD_PROJECT_SUCCESS,
          payload: {
            cardProject,
          },
        });
        return projectData?.data;
      } else {
        return projectData?.response?.data || projectData?.data;
      }
    } catch (error) {
      dispatch({
        type: CARD_PROJECT_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
      return error;
    }
  };

// rename project
export const renameProject =
  (projectId, projectName, isCard) => async (dispatch) => {
    try {
      dispatch({ type: PROJECT_REQUEST });
      let update_response;

      if (!isCard) {
        update_response = await putRequest(
          `/project/updateTitle/${projectId}`,
          {
            name: projectName,
          },
        );
      } else if (isCard) {
        update_response = await putRequest(
          `/project/updateCardTitle/${projectId}`,
          {
            name: projectName,
          },
        );
      }
      const { updatedProject } = update_response?.data;
      dispatch({
        type: RENAME_PROJECT_SUCCESS,
        payload: {
          updatedProject,
        },
      });
      return update_response?.data;
    } catch (error) {
      dispatch({
        type: RENAME_PROJECT_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

// Clone project
export const cloneProject =
  (sourceProjectId, title, isCard) => async (dispatch) => {
    try {
      dispatch({ type: PROJECTS_REQUEST });
      let responseData;
      if (!isCard) {
        responseData = await postRequest("/project/clone", {
          sourceProjectId,
          title,
        });
      } else if (isCard) {
        responseData = await postRequest("/project/cloneACardProject", {
          sourceProjectId,
          title,
        });
      }
      const { project } = responseData?.data || {};
      if (responseData?.data?.success) {
        dispatch({
          type: PROJECT_CREATE_SUCCESS,
          payload: {
            project,
          },
        });
        return responseData;
      } else {
        return responseData;
      }
    } catch (error) {
      dispatch({
        type: PROJECT_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
      return error;
    }
  };

// Get project
export const getProjectDetails = (projectId, isCard) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_REQUEST });
    let response;
    if (!isCard) {
      response = await getRequest(`/project/${projectId}`);
    } else {
      response = await getRequest(`/project/getCardProject/${projectId}`);
    }
    if (response?.data?.success) {
      const {
        credits,
        fontStyle,
        settings,
        members,
        logos,
        _id,
        googleSpreadSheetId,
        googleSheetLink,
        isVideoGenerated,
        renders,
        resolution,
        title,
        isCard,
        creditsIntroEligible,
        lastCreditsSyncedAt: serverLastCreditsSyncedAt,
      } = response?.data?.project;
      const lastCreditsSyncedAt =
        serverLastCreditsSyncedAt || getRememberedCreditsSyncTime(_id);
      rememberCreditsSyncTime(_id, serverLastCreditsSyncedAt);

      dispatch({
        type: PROJECT_SUCCESS,
        payload: {
          _id,
          credits,
          fontStyle,
          settings,
          members,
          logos,
          googleSheetLink,
          googleSpreadSheetId,
          currentBlock: { idx: 0, id: credits[0]?._id },
          isVideoGenerated,
          renders,
          resolution,
          title,
          isCard,
          creditsIntroEligible,
          lastCreditsSyncedAt,
        },
      });
      const project = store.getState().project;
      const objectsMap = createLayoutHistories(
        project.credits,
        project.fontStyle,
      );
      dispatch({ type: UNDO_REDO_SET_STATE, payload: objectsMap });
      dispatch({
        type: SCREEN_UNDO_REDO_SET_STATE,
        payload: createCardScreenHistories(project.credits),
      });
      dispatch({
        type: FONT_UNDO_REDO_SET_STATE,
        payload: createTypographyHistory(project.fontStyle),
      });
    } else {
      // handle unsuccessful response here
    }
    return response;
  } catch (error) {
    dispatch({
      type: PROJECT_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
    return error;
  }
};

// Delete project
export const deleteAProject = (projectId, isCard) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_DELETE_REQUEST });
    // const { data: projectData } = await deleteRequest(`/project/${projectId}`);
    let response;
    if (!isCard) {
      response = await deleteRequest(`/project/${projectId}`);
    } else if (isCard) {
      response = await deleteRequest(`/project/deleteCardProject/${projectId}`);
    }
    const { data: projectData } = response;

    dispatch({
      type: PROJECT_DELETE_SUCCESS,
      payload: { projectId: projectData.projectId },
    });
  } catch (error) {
    dispatch({
      type: PROJECT_DELETE_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

// Update Project Status

export const updateProjectStatus =
  (projectId, projectStatus, idx, isCard) => async (dispatch) => {
    try {
      dispatch({ type: RENAME_PROJECT_REQUEST });
      let updateStatusResponse;
      if (!isCard) {
        updateStatusResponse = await putRequest(
          `/project/updateProjectStatus/${projectId}`,
          { projectStatus: projectStatus, statusId: idx },
        );
      } else if (isCard) {
        updateStatusResponse = await putRequest(
          `/project/updateCardStatus/${projectId}`,
          { projectStatus: projectStatus, statusId: idx },
        );
      }
      const { updatedProject } = updateStatusResponse?.data;
      dispatch({
        type: RENAME_PROJECT_SUCCESS,
        payload: { updatedProject },
      });
    } catch (error) {
      dispatch({
        type: RENAME_PROJECT_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// For Card Layout Navbar  Sync/Reload (Credit Sheet)

// Sync/ Reload By GoogleSheet
export const updateProjectCreditsByGoogle =
  (projectId, spreadsheetId, credit, isCard) => async (dispatch) => {
    try {
      dispatch({ type: PROJECT_CREDITS_UPDATE_REQUEST });
      let data;
      if (!isCard) {
        data = await putRequest(`/project/${projectId}/credits/byGoogle`, {
          credit,
          projectId,
          spreadsheetId,
        });
      } else if (isCard) {
        data = await putRequest(`/project/card/${projectId}/credits/byGoogle`, {
          credit,
          projectId,
          spreadsheetId,
        });
      }
      if (data?.data?.success) {
        let {
          credits,
          fontStyle,
          settings,
          members,
          logos,
          _id,
          googleSpreadSheetId,
          googleSheetLink,
          isVideoGenerated,
          renders,
          title,
          lastCreditsSyncedAt: serverLastCreditsSyncedAt,
        } = data?.data?.project;
        const lastCreditsSyncedAt =
          serverLastCreditsSyncedAt || new Date().toISOString();
        rememberCreditsSyncTime(_id, lastCreditsSyncedAt);

        dispatch({
          type: PROJECT_CREDITS_UPDATE_SUCCESS,
          payload: {
            title,
            _id,
            credits,
            fontStyle,
            settings,
            members,
            logos,
            googleSheetLink,
            googleSpreadSheetId,
            currentBlock: { idx: 0, id: credits[0]?._id },
            isVideoGenerated,
            renders,
            lastCreditsSyncedAt,
          },
        });
        const project = store.getState().project;

        const objectsMap = createLayoutHistories(
          project.credits,
          project.fontStyle,
        );

        dispatch({ type: UNDO_REDO_SET_STATE, payload: objectsMap });
        dispatch({
          type: SCREEN_UNDO_REDO_SET_STATE,
          payload: createCardScreenHistories(project.credits),
        });
        return data?.data;
      } else {
        return data;
      }
    } catch (error) {
      dispatch({
        type: PROJECT_CREDITS_UPDATE_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

// Sync By File Sheet
export const updateProjectCredits =
  (projectId, credits) => async (dispatch) => {
    try {
      dispatch({ type: PROJECT_CREDITS_UPDATE_REQUEST });
      const { data } = await putRequest(`/project/${projectId}/credits/`, {
        credits,
      });

      dispatch({
        type: PROJECT_CREDITS_UPDATE_SUCCESS,
        payload: {
          credits: data.credits,
        },
      });
      const project = store.getState().project;
      const objectsMap = createLayoutHistories(
        project.credits,
        project.fontStyle,
      );
      dispatch({ type: UNDO_REDO_SET_STATE, payload: objectsMap });
      dispatch({
        type: SCREEN_UNDO_REDO_SET_STATE,
        payload: createCardScreenHistories(project.credits),
      });
    } catch (error) {
      dispatch({
        type: PROJECT_CREDITS_UPDATE_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Select Current Block Id From Sidebar And Preview
export const updateCurrentBlockState = (id, idx) => async (dispatch) => {
  dispatch({
    type: CURRENT_BLOCK_UPDATE,
    payload: {
      id,
      idx,
    },
  });
};

//drag and drop action
export const moveBlock = (sourceIdx, targetIdx) => async (dispatch) => {
  dispatch({
    type: BLOCK_MOVE,
    payload: {
      sourceIdx,
      targetIdx,
    },
  });
};

// Options - Select Type => Font/Layout
export const selectedOption = (isOptionSelected) => (dispatch) => {
  try {
    dispatch({ type: OPTION_REQUEST });
    dispatch({
      type: PROJECT_OPTION_SUCCESS,
      payload: isOptionSelected,
    });
  } catch (error) {
    return error;
  }
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Options - Blocks(RoleName/NameOnly/Blurb/Songs) - Call Both Function
export const updateProjectCreditOptionsState =
  (creditsIdx, optionKey, optionValue, recordLayoutHistory = false) =>
  (dispatch) => {
    dispatch({
      type: PROJECT_CREDIT_OPTIONS_STATE_UPDATE,
      payload: {
        creditsIdx,
        optionKey,
        optionValue,
      },
    });

    if (!recordLayoutHistory) return;

    const state = store.getState();
    const credit = state.project?.credits?.[creditsIdx];
    if (!credit || credit.options?.block_type?.toLowerCase() === "logo") return;

    const history = state.undoRedo;
    if (!Array.isArray(history)) return;

    const entry =
      history.find((item) => item.creditsId === credit._id) ||
      history[creditsIdx];
    if (!entry?.obj) return;

    entry.layoutFontObj?.breakCoalescing?.();

    const changed = entry.obj.push(credit.options, {
      groupKey: optionKey,
    });
    if (changed) {
      dispatch({ type: UNDO_REDO_SET_STATE, payload: [...history] });
    }
  };

const optionSaveSeq = {};

export const saveOptionById =
  (creditsId, isCard, currentBlockOptions) => (dispatch) => {
    if (!creditsId) {
      dispatch({
        type: PROJECT_FAIL,
        payload: { error: "Error: no current options id to save" },
      });
      return;
    }

    const { credits, _id: projectId } = store.getState().project;
    const idx = credits.findIndex((credit) => credit._id == creditsId);
    if (idx == -1) {
      dispatch({
        type: PROJECT_FAIL,
        payload: { error: "Error in saving options" },
      });
      return;
    }

    // Capture the edited value now. Reading Redux inside the delayed callback
    // allowed a render-page reload to replace it with an older server value.
    const optionsToSave = cloneProjectValue(
      currentBlockOptions || credits[idx].options,
    );
    optionSaveSeq[creditsId] = (optionSaveSeq[creditsId] || 0) + 1;
    const seq = optionSaveSeq[creditsId];
    const saveKey = `credit-options:${projectId}:${creditsId}`;

    return scheduleProjectSave(saveKey, async () => {
      try {
        const url = isCard
          ? `/project/card/${projectId}/credits/${creditsId}/options`
          : `/project/${projectId}/credits/${creditsId}/options`;
        const response = await putRequest(url, optionsToSave);
        requireSuccessfulResponse(
          response,
          "Unable to save the block layout",
        );

        if (
          seq === optionSaveSeq[creditsId] &&
          store.getState().project?._id === projectId
        ) {
          dispatch({
            type: PROJECT_OPTION_SUCCESS,
            payload: {
              creditsId,
              preserveOptions: true,
            },
          });
        }
      } catch (error) {
        if (
          seq === optionSaveSeq[creditsId] &&
          store.getState().project?._id === projectId
        ) {
          dispatch({
            type: PROJECT_FAIL,
            payload: {
              error: error.response?.data?.message || error.message,
            },
          });
        }
        throw error;
      }
    }, 200);
  };

const getScreenHistoryEntry = (history, creditsId, creditsIdx) =>
  Array.isArray(history)
    ? history.find((entry) => entry.creditsId === creditsId) ||
      history[creditsIdx]
    : null;

const publishScreenHistory = (dispatch, history) => {
  dispatch({ type: SCREEN_UNDO_REDO_SET_STATE, payload: [...history] });
};

export const updateCardScreenOptions =
  (creditsId, changes, groupKey) => (dispatch) => {
    if (!creditsId || !changes) return;

    const state = store.getState();
    const credits = state.project?.credits;
    const creditsIdx = credits?.findIndex((credit) => credit._id === creditsId);
    if (creditsIdx == null || creditsIdx === -1) return;

    const currentOptions = credits[creditsIdx].options;
    const nextOptions = { ...cloneProjectValue(currentOptions), ...changes };
    if (JSON.stringify(nextOptions) === JSON.stringify(currentOptions)) return;

    dispatch({
      type: PROJECT_OPTION_SUCCESS,
      payload: { creditsId, options: nextOptions },
    });

    const history = Array.isArray(state.screenUndoRedo)
      ? [...state.screenUndoRedo]
      : [];
    let entry = getScreenHistoryEntry(history, creditsId, creditsIdx);
    if (!entry || entry.creditsId !== creditsId) {
      const obj = new UndoRedo();
      obj.push(getCardScreenSnapshot(currentOptions));
      entry = { obj, index: creditsIdx, creditsId };
      history.push(entry);
    }

    if (
      entry.obj.push(getCardScreenSnapshot(nextOptions), {
        groupKey: groupKey || Object.keys(changes).sort().join(":"),
      })
    ) {
      publishScreenHistory(dispatch, history);
    }

    return dispatch(saveOptionById(creditsId, true, nextOptions));
  };

const moveCardScreenHistory =
  (direction, creditsId) => async (dispatch) => {
    if (!creditsId) return;

    try {
      await flushPendingProjectSaves();
    } catch {
      return;
    }

    const state = store.getState();
    const credits = state.project?.credits;
    const creditsIdx = credits?.findIndex((credit) => credit._id === creditsId);
    if (creditsIdx == null || creditsIdx === -1) return;

    const history = state.screenUndoRedo;
    const entry = getScreenHistoryEntry(history, creditsId, creditsIdx);
    const stack = entry?.obj;
    const canMove = direction === "undo" ? stack?.canUndo : stack?.canRedo;
    if (!canMove) return;

    const previousPosition = stack.getPosition;
    const currentOptions = cloneProjectValue(credits[creditsIdx].options);
    const screenOptions =
      direction === "undo" ? stack.getPreviousState : stack.getNextState;
    const nextOptions = { ...currentOptions, ...screenOptions };

    publishScreenHistory(dispatch, history);
    dispatch({
      type: PROJECT_OPTION_SUCCESS,
      payload: { creditsId, options: nextOptions },
    });

    try {
      await dispatch(saveOptionById(creditsId, true, nextOptions));
    } catch {
      stack.setPosition(previousPosition);
      publishScreenHistory(dispatch, history);
      dispatch({
        type: PROJECT_OPTION_SUCCESS,
        payload: { creditsId, options: currentOptions },
      });
    }
  };

export const undoCardScreen = (creditsId) =>
  moveCardScreenHistory("undo", creditsId);

export const redoCardScreen = (creditsId) =>
  moveCardScreenHistory("redo", creditsId);

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// updateSettingOptionState // Aditional Extra Global Settings - Gutter / Ragged Gutter (In Footer)
export const updateSettingOptionState =
  (settingsKey, settingsvalue) => async (dispatch) => {
    dispatch({
      type: SETTING_OPTION_STATE,
      payload: {
        settingsKey,
        settingsvalue,
      },
    });
  };

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const updateFontStyleState =
  (key, property, value, currentBlockType, recordTypographyHistory = false) =>
  async (dispatch) => {
    if (currentBlockType === "nameonly" && key === "name") {
      key = "nameOnlyStyle";
      dispatch({
        type: FONT_STYLE_UPDATE,
        payload: { key, property, value },
      });
    } else if (
      currentBlockType === "rolename" &&
      key === "role" &&
      property === "lineHeight"
    ) {
      key = "role";
      dispatch({
        type: FONT_STYLE_UPDATE,
        payload: { key, property, value },
      });
    } else {
      dispatch({
        type: FONT_STYLE_UPDATE,
        payload: { key, property, value },
      });
    }

    if (!recordTypographyHistory) return;

    const state = store.getState();
    const stack = state.fontUndoRedo?.obj;
    if (!stack) return;

    const changed = stack.push(state.project?.fontStyle, {
      groupKey: `${key}:${property}`,
    });
    if (changed) {
      dispatch({
        type: FONT_UNDO_REDO_SET_STATE,
        payload: { ...state.fontUndoRedo },
      });
    }
  };

// Layout owns a small set of typography-backed controls (line height and the
// Role + Name row gap). Keep those changes in the selected block's Layout
// history instead of mixing them into the Typography tab's global history.
export const updateLayoutFontStyleState =
  (creditsId, creditsIdx, changes, groupKey) => (dispatch) => {
    const state = store.getState();
    const credit =
      state.project?.credits?.find((item) => item._id === creditsId) ||
      state.project?.credits?.[creditsIdx];
    const history = state.undoRedo;
    const entry = Array.isArray(history)
      ? history.find((item) => item.creditsId === credit?._id) ||
        history[creditsIdx]
      : null;

    const blockType = credit?.options?.block_type?.toLowerCase();
    const beforeSnapshot = getLayoutTypographySnapshot(
      blockType,
      state.project?.fontStyle,
    );
    let layoutFontObj = entry?.layoutFontObj;
    if (
      entry &&
      (!layoutFontObj ||
        JSON.stringify(layoutFontObj.top) !== JSON.stringify(beforeSnapshot))
    ) {
      // Typography-tab changes intentionally live in a separate history. If
      // they changed the same shared style, begin this Layout sequence from
      // the value currently on screen instead of undoing across tab scopes.
      layoutFontObj = new UndoRedo();
      layoutFontObj.push(beforeSnapshot);
      history.forEach((historyEntry, historyIndex) => {
        const historyCredit =
          state.project?.credits?.find(
            (item) => item._id === historyEntry.creditsId,
          ) || state.project?.credits?.[historyIndex];
        if (historyCredit?.options?.block_type?.toLowerCase() === blockType) {
          historyEntry.layoutFontObj = layoutFontObj;
        }
      });
    }

    (changes || []).forEach(({ styleKey, property, value }) => {
      if (!styleKey || !property) return;
      dispatch({
        type: FONT_STYLE_UPDATE,
        payload: { key: styleKey, property, value },
      });
    });

    if (!layoutFontObj || !credit) return;

    entry.obj?.breakCoalescing?.();

    const changed = layoutFontObj.push(
      getLayoutTypographySnapshot(
        credit.options?.block_type,
        store.getState().project?.fontStyle,
      ),
      { groupKey },
    );
    if (changed) {
      dispatch({ type: UNDO_REDO_SET_STATE, payload: [...history] });
      rebaseTypographyHistory(dispatch, layoutFontObj.top);
    }
  };

// Font Settings
export const saveFontStyle =
  (
    fontStyleType,
    currentBlockType,
    key,
    value,
    notifyWithToast,
    isCard,
    saveContext,
  ) =>
    (dispatch) => {
      const activeProject = store.getState().project;
      const projectId = saveContext?.projectId || activeProject._id;
      const projectIsCard = saveContext?.isCard ?? isCard ?? activeProject.isCard;
      const fontStyle = activeProject.fontStyle;
      const fontStylePreBody = cloneProjectValue(fontStyle?.fontStyleBody);
      const selectedFontStyle = cloneProjectValue(
        saveContext?.fontStyle || fontStyle?.[fontStyleType],
      );
      const optimisticSave = saveContext?.optimistic === true;
      const newFontStyle = { ...(selectedFontStyle || {}) };
      delete newFontStyle._id;
      const saveKey = `font-style:${projectId}:${fontStyleType}`;

      return runProjectSave(saveKey, async () => {
        try {
          if (
            !optimisticSave &&
            store.getState().project?._id === projectId
          ) {
            dispatch({ type: PROJECT_REQUEST });
          }

          // Proceed only if the fontStyle body is different
          if (
            saveContext?.fontStyle ||
            typeof fontStylePreBody === "undefined" ||
            JSON.stringify(fontStylePreBody) !==
            JSON.stringify(selectedFontStyle)
          ) {
            const url = projectIsCard
              ? `/project/card/${projectId}/fontStyle/${fontStyleType}`
              : `/project/${projectId}/fontStyle/${fontStyleType}`;
            const response = await putRequest(url, newFontStyle);
            const data = requireSuccessfulResponse(
              response,
              "Unable to save the typography settings",
            );

            if (store.getState().project?._id === projectId) {
              dispatch({
                type: PROJECT_FONTSTYLE_UPDATE_SUCCESS,
                payload: {
                  fontStyle: data.fontStyle,
                  fontStyleType,
                  fontStyleBody: selectedFontStyle,
                  preserveLocalFontStyle: optimisticSave,
                },
              });
            }

            // Optional: enable toast
            // notifyWithToast?.({ keyName: key, value, data: data?.success });
          }
        } catch (error) {
          if (store.getState().project?._id === projectId) {
            dispatch({
              type: PROJECT_FAIL,
              payload: {
                error: error.response?.data?.message || error.message,
              },
            });
          }
          throw error;
        }
      });
    };

const typographyMetadataKeys = new Set(["_id", "fontStyleBody"]);

const getChangedTypographyStyles = (currentFontStyle, targetFontStyle) =>
  Object.keys({ ...(currentFontStyle || {}), ...(targetFontStyle || {}) }).filter(
    (styleKey) =>
      !typographyMetadataKeys.has(styleKey) &&
      targetFontStyle?.[styleKey] &&
      typeof targetFontStyle[styleKey] === "object" &&
      JSON.stringify(currentFontStyle?.[styleKey]) !==
        JSON.stringify(targetFontStyle[styleKey]),
  );

const publishTypographyHistory = (dispatch, historyState) => {
  dispatch({
    type: FONT_UNDO_REDO_SET_STATE,
    payload: { ...historyState },
  });
};

const applyTypographyHistoryState = (dispatch, fontStyle) => {
  dispatch({
    type: FONT_STYLE_HISTORY_APPLY,
    payload: cloneProjectValue(fontStyle),
  });
};

const moveTypographyHistory =
  (direction, isCard) => async (dispatch) => {
    try {
      // Typography controls debounce their saves. Finish those writes before
      // applying history so an older save cannot overwrite the undo/redo.
      await flushPendingProjectSaves();
    } catch {
      return;
    }

    const state = store.getState();
    const historyState = state.fontUndoRedo;
    const stack = historyState?.obj;
    const canMove = direction === "undo" ? stack?.canUndo : stack?.canRedo;
    if (!canMove) return;

    const currentFontStyle = cloneProjectValue(state.project?.fontStyle);
    const projectId = state.project?._id;
    const previousPosition = stack.getPosition;
    const targetFontStyle =
      direction === "undo" ? stack.getPreviousState : stack.getNextState;
    const changedStyles = getChangedTypographyStyles(
      currentFontStyle,
      targetFontStyle,
    );

    publishTypographyHistory(dispatch, historyState);
    applyTypographyHistoryState(dispatch, targetFontStyle);

    try {
      for (const styleKey of changedStyles) {
        const styleToSave = cloneProjectValue(targetFontStyle[styleKey]);
        delete styleToSave._id;
        const url = isCard
          ? `/project/card/${projectId}/fontStyle/${styleKey}`
          : `/project/${projectId}/fontStyle/${styleKey}`;

        await runProjectSave(
          `font-history:${projectId}:${styleKey}`,
          async () => {
            const { data } = await putRequest(url, styleToSave);
            if (!data?.success) throw new Error("Typography change was not saved");
            dispatch({
              type: PROJECT_FONTSTYLE_UPDATE_SUCCESS,
              payload: {
                fontStyle: data.fontStyle,
                fontStyleType: styleKey,
                fontStyleBody: targetFontStyle[styleKey],
              },
            });
          },
        );
      }
    } catch (error) {
      stack.setPosition(previousPosition);
      publishTypographyHistory(dispatch, historyState);
      applyTypographyHistoryState(dispatch, currentFontStyle);
      dispatch({
        type: PROJECT_FAIL,
        payload: {
          error: error.response?.data?.message || error.message,
        },
      });
    }
  };

export const undoTypography = (isCard) =>
  moveTypographyHistory("undo", isCard);

export const redoTypography = (isCard) =>
  moveTypographyHistory("redo", isCard);

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const updateAProjectCreditItemsState =
  (creditsId, items) => (dispatch) => {
    dispatch({
      type: PROJECT_CREDITS_ITEMS_UPDATE_SUCCESS,
      payload: {
        items,
        creditsId,
      },
    });
  };

export const saveProjectSettings =
  (settingsOverride, saveContext) => (dispatch) => {
    const project = store.getState().project;
    const projectId = saveContext?.projectId || project._id;
    const isCard = saveContext?.isCard ?? project.isCard;
    const requestedSettings = cloneProjectValue(
      settingsOverride || project.settings,
    );
    const settings = cloneProjectValue(requestedSettings);
    const saveKey = `project-settings:${projectId}`;

    return runProjectSave(saveKey, async () => {
      try {
        if (store.getState().project?._id === projectId) {
          dispatch({ type: PROJECT_REQUEST });
        }
        if (settings.variant === null || settings.variant === undefined)
          settings.variant = " ";
        delete settings._id;
        const settingsUrl = isCard
          ? `/project/${projectId}/settings/?isCard=true`
          : `/project/${projectId}/settings/`;
        const response = await putRequest(settingsUrl, settings);
        const data = requireSuccessfulResponse(
          response,
          "Unable to save the project settings",
        );

        if (store.getState().project?._id === projectId) {
          const currentSettings = store.getState().project?.settings;
          const preserveLocalSettings =
            JSON.stringify(currentSettings) !==
            JSON.stringify(requestedSettings);
          dispatch({
            type: PROJECT_SETTINGS_UPDATE_SUCCESS,
            payload: {
              settings: data.settings,
              preserveLocalSettings,
            },
          });
        }
      } catch (error) {
        if (store.getState().project?._id === projectId) {
          dispatch({
            type: PROJECT_FAIL,
            payload: {
              error: error.response?.data?.message || error.message,
            },
          });
        }
        throw error;
      }
    });
  };

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// save global screen option for cards
export const saveGlobalOption =
  (creditsId, currentBlockChangedOptions) => async (dispatch) => {
    try {
      dispatch({ type: PROJECT_REQUEST });

      if (!creditsId) throw Error("Error: no current options id to save");

      const { credits, _id: projectId } = store.getState().project;
      const idx = credits.findIndex((credit) => credit._id == creditsId);
      if (idx == -1) throw Error("Error in saving options");
      const options = credits[idx].options;

      const url = `/project/card/${projectId}/credits/${creditsId}/global-options`;

      if (currentBlockChangedOptions) {
        const { data } = await putRequest(url, currentBlockChangedOptions);
        if (data?.success) {
          dispatch({
            type: PROJECT_GLOBAL_OPTION_SUCCESS,
            payload: {
              updatedOptions: currentBlockChangedOptions,
            },
          });
          dispatch({
            type: SCREEN_UNDO_REDO_SET_STATE,
            payload: createCardScreenHistories(
              store.getState().project?.credits,
            ),
          });
        }
      }
    } catch (error) {
      dispatch({
        type: PROJECT_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

export const saveProjectGlobalOption =
  (creditsId, currentBlockChangedOptions, block_type, isCard) =>
    async (dispatch) => {
      try {
        dispatch({ type: PROJECT_REQUEST });

        if (!creditsId) throw Error("Error: no current options id to save");

        const { credits, _id: projectId } = store.getState().project;
        const idx = credits.findIndex((credit) => credit._id == creditsId);
        if (idx == -1) throw Error("Error in saving options");
        const options = credits[idx].options;

        const url = `/project/${projectId}/credits/${creditsId}/global-options`;

        if (currentBlockChangedOptions) {
          const { data } = await putRequest(url, {
            block_type,
            currentBlockChangedOptions,
            isCard,
          });
          if (data?.success) {
            dispatch({
              type: PROJECT_SCROLL_GLOBAL_OPTION_SUCCESS,
              payload: {
                updatedProjectOptions: data?.options,
                block_type,
                currentBlockChangedOptions,
              },
            });
          }
        }
      } catch (error) {
        dispatch({
          type: PROJECT_FAIL,
          payload: {
            error:
              error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
          },
        });
      }
    };

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Undo/Redo
const getLayoutHistoryEntry = (history, creditsId, creditsIdx) =>
  Array.isArray(history)
    ? history.find((entry) => entry.creditsId === creditsId) ||
      history[creditsIdx]
    : null;

const publishLayoutHistory = (dispatch, history) => {
  dispatch({ type: UNDO_REDO_SET_STATE, payload: [...history] });
};

const applyLayoutHistoryState = (dispatch, creditsId, options) => {
  dispatch({
    type: PROJECT_OPTION_SUCCESS,
    payload: {
      options: cloneProjectValue(options),
      creditsId,
    },
  });
};

const applyLayoutPresetTypography = (
  dispatch,
  state,
  isCard,
  typographyOverrides,
) => {
  if (!typographyOverrides || typeof typographyOverrides !== "object") {
    return [];
  }

  const currentFontStyle = cloneProjectValue(state.project?.fontStyle || {});
  const nextFontStyle = cloneProjectValue(currentFontStyle);

  Object.entries(typographyOverrides).forEach(([styleKey, properties]) => {
    if (!properties || typeof properties !== "object") return;
    nextFontStyle[styleKey] = {
      ...(nextFontStyle[styleKey] || {}),
      ...cloneProjectValue(properties),
    };
  });

  const changedStyleKeys = getChangedTypographyStyles(
    currentFontStyle,
    nextFontStyle,
  );
  if (!changedStyleKeys.length) return [];

  applyTypographyHistoryState(dispatch, nextFontStyle);

  const historyState = state.fontUndoRedo;
  if (historyState?.obj?.push(nextFontStyle)) {
    publishTypographyHistory(dispatch, historyState);
  }

  const projectId = state.project?._id;
  return changedStyleKeys.map((styleKey) =>
    dispatch(
      saveFontStyle(
        styleKey,
        "rolename",
        "preset",
        null,
        null,
        isCard,
        {
          projectId,
          isCard,
          fontStyle: nextFontStyle[styleKey],
          optimistic: true,
        },
      ),
    ),
  );
};

export const applyLayoutPreset =
  (creditsId, isCard, presetOptions, typographyOverrides) => (dispatch) => {
    if (!creditsId || !presetOptions) return;

    const state = store.getState();
    const credits = state.project?.credits;
    const creditsIdx = credits?.findIndex((credit) => credit._id === creditsId);
    if (creditsIdx == null || creditsIdx === -1) return;

    const credit = credits[creditsIdx];
    const nextOptions = {
      ...cloneProjectValue(credit.options),
      ...cloneProjectValue(presetOptions),
    };
    const layoutChanged =
      JSON.stringify(nextOptions) !== JSON.stringify(credit.options);
    let layoutSave = null;

    if (layoutChanged) {
      applyLayoutHistoryState(dispatch, creditsId, nextOptions);

      if (nextOptions.block_type?.toLowerCase() !== "logo") {
        const history = state.undoRedo;
        const entry = getLayoutHistoryEntry(history, creditsId, creditsIdx);
        if (entry?.obj?.push(nextOptions)) {
          publishLayoutHistory(dispatch, history);
        }
      }

      layoutSave = dispatch(saveOptionById(creditsId, isCard, nextOptions));
    }

    const typographySaves = applyLayoutPresetTypography(
      dispatch,
      state,
      isCard,
      typographyOverrides,
    );
    const saves = [layoutSave, ...typographySaves].filter(Boolean);

    if (!saves.length) return nextOptions;
    if (saves.length === 1) return saves[0];
    return Promise.all(saves);
  };

const moveLayoutHistory =
  (direction, creditsId, isCard) => async (dispatch) => {
    if (!creditsId) return;

    const state = store.getState();
    const credits = state.project?.credits;
    const creditsIdx = credits?.findIndex((credit) => credit._id === creditsId);
    if (creditsIdx == null || creditsIdx === -1) return;

    const history = state.undoRedo;
    const entry = getLayoutHistoryEntry(history, creditsId, creditsIdx);
    const stack = entry?.obj;
    const canMove = direction === "undo" ? stack?.canUndo : stack?.canRedo;
    if (!canMove) return;

    const previousPosition = stack.getPosition;
    const options =
      direction === "undo" ? stack.getPreviousState : stack.getNextState;

    publishLayoutHistory(dispatch, history);
    applyLayoutHistoryState(dispatch, creditsId, options);

    try {
      await dispatch(saveOptionById(creditsId, isCard, options));
    } catch {
      stack.setPosition(previousPosition);
      publishLayoutHistory(dispatch, history);
      applyLayoutHistoryState(dispatch, creditsId, stack.top);
    }
  };

const moveLayoutFontHistory =
  (direction, creditsId, isCard) => async (dispatch) => {
    const state = store.getState();
    const credits = state.project?.credits;
    const creditsIdx = credits?.findIndex((credit) => credit._id === creditsId);
    if (creditsIdx == null || creditsIdx === -1) return;

    const history = state.undoRedo;
    const entry = getLayoutHistoryEntry(history, creditsId, creditsIdx);
    const stack = entry?.layoutFontObj;
    const canMove = direction === "undo" ? stack?.canUndo : stack?.canRedo;
    if (!canMove) return;

    const currentFontStyle = cloneProjectValue(state.project?.fontStyle || {});
    const previousPosition = stack.getPosition;
    const snapshot =
      direction === "undo" ? stack.getPreviousState : stack.getNextState;
    const targetFontStyle = mergeLayoutTypographySnapshot(
      currentFontStyle,
      snapshot,
    );
    const changedStyles = getChangedTypographyStyles(
      currentFontStyle,
      targetFontStyle,
    );

    publishLayoutHistory(dispatch, history);
    applyTypographyHistoryState(dispatch, targetFontStyle);
    rebaseTypographyHistory(dispatch, snapshot);

    try {
      for (const styleKey of changedStyles) {
        await dispatch(
          saveFontStyle(
            styleKey,
            credits[creditsIdx]?.options?.block_type,
            "layout-history",
            null,
            null,
            isCard,
            {
              projectId: state.project?._id,
              isCard,
              fontStyle: targetFontStyle[styleKey],
              optimistic: true,
            },
          ),
        );
      }
    } catch {
      stack.setPosition(previousPosition);
      publishLayoutHistory(dispatch, history);
      applyTypographyHistoryState(dispatch, currentFontStyle);
      rebaseTypographyHistory(
        dispatch,
        getLayoutTypographySnapshot(
          credits[creditsIdx]?.options?.block_type,
          currentFontStyle,
        ),
      );
    }
  };

const moveLayoutControlHistory =
  (direction, creditsId, isCard) => async (dispatch) => {
    if (!creditsId) return;

    try {
      // Layout font controls debounce their writes. Complete them first so an
      // older line-height/row-gap save cannot land after this undo or redo.
      await flushPendingProjectSaves();
    } catch {
      return;
    }

    const state = store.getState();
    const creditsIdx = state.project?.credits?.findIndex(
      (credit) => credit._id === creditsId,
    );
    if (creditsIdx == null || creditsIdx === -1) return;

    const entry = getLayoutHistoryEntry(
      state.undoRedo,
      creditsId,
      creditsIdx,
    );
    const optionsStack = entry?.obj;
    const fontStack = entry?.layoutFontObj;
    const optionsCanMove =
      direction === "undo" ? optionsStack?.canUndo : optionsStack?.canRedo;
    const fontCanMove =
      direction === "undo" ? fontStack?.canUndo : fontStack?.canRedo;
    if (!optionsCanMove && !fontCanMove) return;

    optionsStack?.breakCoalescing?.();
    fontStack?.breakCoalescing?.();

    const optionsTime =
      direction === "undo"
        ? optionsStack?.undoTimestamp ?? -Infinity
        : optionsStack?.redoTimestamp ?? Infinity;
    const fontTime =
      direction === "undo"
        ? fontStack?.undoTimestamp ?? -Infinity
        : fontStack?.redoTimestamp ?? Infinity;
    const useFontHistory =
      fontCanMove &&
      (!optionsCanMove ||
        (direction === "undo"
          ? fontTime >= optionsTime
          : fontTime <= optionsTime));

    return dispatch(
      useFontHistory
        ? moveLayoutFontHistory(direction, creditsId, isCard)
        : moveLayoutHistory(direction, creditsId, isCard),
    );
  };

export const undoOptions = (creditsId, isCard) =>
  moveLayoutControlHistory("undo", creditsId, isCard);

export const redoOptions = (creditsId, isCard) =>
  moveLayoutControlHistory("redo", creditsId, isCard);

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Get Default Logo
export const getDefalutLogos = () => async (dispatch) => {
  try {
    dispatch({ type: PROJECTS_REQUEST });
    const isCard = JSON.parse(localStorage.getItem("isCard"));
    const response = await postRequest(
      `/project/getDefaultImages?isCard=${isCard}`,
    );
    if (response?.data?.success) {
      let defaultLogos = [];
      // defaultLogos = [...response.data.users_logos];
      defaultLogos = [
        ...response.data.users_logos,
        ...response.data.formattedLogos,
      ];
      dispatch({
        type: DEFAULT_LOGO_SUCCESS,
        payload: defaultLogos,
      });
      return response?.data;
    } else {
      dispatch({
        type: PROJECTS_FAIL,
        payload: {
          error: response,
        },
      });
      return response;
    }
  } catch (error) {
    dispatch({
      type: PROJECTS_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

export const deleteLogoAsset =
  (projectId, logoId, isCard) => async (dispatch) => {
    try {
      dispatch({ type: PROJECTS_REQUEST });
      const response = await postRequest(
        `/project/deleteLogos?isCard=${Boolean(isCard)}`,
        { project_id: projectId, logo_id: logoId },
      );
      if (!response?.data?.success) {
        throw new Error(
          response?.data?.error || "The logo could not be deleted",
        );
      }
      await dispatch(getDefalutLogos());
      return response.data;
    } catch (error) {
      dispatch({
        type: PROJECTS_FAIL,
        payload: {
          error: error.response?.data?.message || error.message,
        },
      });
      return { success: false, error: error.message };
    }
  };

// Upload Logo
export const uploadLogoDetails = (filedata, creditID) => async (dispatch) => {
  console.log("3 API call upload logo");
  try {
    dispatch({ type: PROJECTS_REQUEST });
    const { _id: projectId } = store.getState().project;
    const response = await postRequest(
      `/project/${projectId}/${creditID}/logoUpload`,
      filedata,
    );
    console.log("4 API call Response upload logo response => ", response);
    if (response?.data?.success) {
      dispatch({
        type: PROJECT_LOGO_UPLOAD_SUCCESS,
        payload: {
          logos: response?.data?.uploadedLogos,
        },
      });
      const uploadedLogo = getUploadedLogo(response.data, projectId);
      if (uploadedLogo) {
        dispatch({
          type: DEFAULT_LOGO_SUCCESS,
          payload: mergeUploadedLogo(
            store.getState().commonReducer?.defaultLogos,
            uploadedLogo,
          ),
        });
      }
      return response?.data;
    } else {
      const { data } = response.response;
      const { error: message, success } = data;
      return { message, success };
    }
  } catch (error) {
    dispatch({
      type: PROJECT_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
    if (error.response && error.response.data) {
      const { data } = error.response;
      const { error: message, success } = data;
      return { message, success };
    }
  }
};

// Call From Logo update
export const updateProjectCreditItems =
  (creditsId, items, saveContext) => async (dispatch) => {
    const activeProject = store.getState().project;
    const projectId = saveContext?.projectId || activeProject._id;
    const isCard =
      saveContext?.isCard ?? JSON.parse(localStorage.getItem("isCard"));
    try {
      if (store.getState().project?._id === projectId) {
        dispatch({ type: PROJECT_REQUEST });
      }
      const response = await putRequest(
        `/project/${projectId}/credits/${creditsId}/items`,
        {
          items,
          isCard,
        },
      );
      const data = response?.data;
      if (!data?.success || !Array.isArray(data?.items)) {
        throw new Error(data?.error || "The logo changes could not be saved");
      }
      if (store.getState().project?._id === projectId) {
        dispatch({
          type: PROJECT_CREDITS_ITEMS_UPDATE_SUCCESS,
          payload: {
            items: data.items,
            creditsId,
            dataSaved: true,
          },
        });
      }
    } catch (error) {
      if (store.getState().project?._id === projectId) {
        dispatch({
          type: PROJECT_FAIL,
          payload: {
            error:
              error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
          },
        });
      }
      throw error;
    }
  };

// Render Action Call ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const requestRenderXVideo =
  (images, reqBody, extraFiles = {}) => async (dispatch) => {
    console.log("4 Scroll RenderAPI Call Request => ");
    try {
      dispatch({ type: PROJECT_REQUEST });
      const formData = new FormData();
      images.forEach((image) =>
        formData.append("preview", image.blob, `preview-${image.idx + 1}`),
      );
      if (extraFiles.endHoldForeground) {
        formData.append(
          "preview",
          extraFiles.endHoldForeground,
          "end-hold-foreground",
        );
      }
      Object.keys(reqBody).forEach((key) => formData.append(key, reqBody[key]));
      const { _id: projectId } = store.getState().project;
      const response = await postRequest(`/renderx/${projectId}/`, formData);
      const data = requireSuccessfulResponse(
        response,
        "Unable to start the Scroll render",
      );
      console.log("5 Scroll render API Response data => ", data);
      dispatch({
        type: PROJECT_RENDER_REQUEST_SUCCESS,
        payload: { renders: data.renders },
      });
      return data;
    } catch (error) {
      const message =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        "Unable to start the Scroll render";
      dispatch({
        type: PROJECT_FAIL,
        payload: { error: message },
      });
      return { success: false, error: message };
    }
  };

export const requestRenderX3Video =
  (images = [], cardScreenOptions = {}, reqBody = {}) =>
    async (dispatch) => {
      console.log("4 Card RenderAPI Call Request => ");
      try {
        dispatch({ type: PROJECT_REQUEST });

        if (!Array.isArray(images) || !reqBody || !cardScreenOptions) {
          throw new Error("Invalid parameters passed.");
        }

        const formData = new FormData();

        images.forEach((image) => {
          if (image?.blob) {
            formData.append(
              "preview",
              image.blob,
              `preview-${image.idx + 1}`,
            );
          }
        });

        formData.append(
          "cardScreenOptions",
          typeof cardScreenOptions === "object"
            ? JSON.stringify(cardScreenOptions)
            : String(cardScreenOptions),
        );

        Object.entries(reqBody).forEach(([key, value]) => {
          if (value == null) return;
          formData.append(
            key,
            typeof value === "object" ? JSON.stringify(value) : String(value),
          );
        });

        const state = store.getState();
        if (!state?.project?._id) {
          throw new Error("Project ID not found in store.");
        }
        const projectId = state.project._id;

        const response = await postRequest(
          `/renderx/card/${projectId}/`,
          formData,
        );
        if (response?.isAxiosError || !(response?.status >= 200 && response?.status < 300)) {
          const message =
            response?.response?.data?.error ||
            response?.response?.data?.message ||
            response?.data?.error ||
            response?.message ||
            "Card render request failed";
          dispatch({
            type: PROJECT_FAIL,
            payload: { error: message },
          });
          return { success: false, error: message };
        }
        const { data } = response;
        console.log('5 Card render API Response data => ',data);
        if (!data?.success) {
          const message = data?.error || data?.message || "Card render request failed";
          dispatch({
            type: PROJECT_FAIL,
            payload: { error: message },
          });
          return { success: false, error: message };
        }
        dispatch({
          type: PROJECT_RENDER_REQUEST_SUCCESS,
          payload: { renders: data.renders },
        });

        return data;
      } catch (error) {
        console.error("Request failed:", error);
        const message =
          error.response?.data?.message ||
          error.message ||
          "Unknown error occurred";
        dispatch({
          type: PROJECT_FAIL,
          payload: { error: message },
        });
        return { success: false, error: message };
      }
    };

export const deleteRenders =
  (projectId, renderId, isCard) => async (dispatch) => {
    try {
      dispatch({ type: PROJECT_REQUEST });
      let response;
      if (isCard) {
        response = await deleteRequest(
          `/project/card/deleteOneRender/${projectId}/${renderId}`,
        );
      } else {
        response = await deleteRequest(
          `/project/deleteOneRender/${projectId}/${renderId}`,
        );
      }
      if (response?.data?.success) {
        dispatch({
          type: RENDER_DELETE_SUCCESS,
          payload: { renderId: response?.data?.RenderId },
        });
      } else {
        dispatch({
          type: RENDER_DELETE_FAIL,
          payload: {
            error: response?.data?.error,
          },
        });
      }
    } catch (error) {
      dispatch({
        type: RENDER_DELETE_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

//delete all render
export const deleteAllRenders = (projectId) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_REQUEST });
    const response = await deleteRequest(
      `/project/deleteAllRenders/${projectId}`,
    );
    if (response?.data?.success) {
      dispatch({
        type: RENDER_DELETE_All_SUCCESS,
        payload: { deleterenders: response?.data?.renders },
      });
      return response?.data;
    } else {
      dispatch({
        type: RENDER_DELETE_ALL_FAIL,
        payload: {
          error: response?.data?.error,
        },
      });
      return response?.data;
    }
  } catch (error) {
    dispatch({
      type: RENDER_DELETE_ALL_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

// download render video link
export const downloadRender =
  (projectId, renderId, type) => async (dispatch) => {
    try {
      dispatch({ type: DOWNLOAD_RENDER_REQUEST });
      const isCard = type === "Card" ? true : false;
      let response;
      if (!isCard) {
        response = await getRequest(`/renderx/${projectId}/${renderId}`);
      } else if (isCard) {
        response = await getRequest(`/renderx/card/${projectId}/${renderId}`);
      }
      return response?.data;
    } catch (error) {
      dispatch({
        type: RENDER_DELETE_ALL_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

export const downloadCardRender = (projectId, renderId) => async (dispatch) => {
  try {
    dispatch({ type: DOWNLOAD_RENDER_REQUEST });
    const response = await getRequest(`/renderx/card/${projectId}/${renderId}`);
    return response?.data;
  } catch (error) {
    dispatch({
      type: RENDER_DELETE_ALL_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// function to fetch all data for helpPage
export const getHelpPageData = () => async (dispatch) => {
  try {
  } catch (error) {
    dispatch({
      type: HELP_PAGE_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

// get stripe data
// get stripe data
export const getUserStripeData = () => async (dispatch) => {
  try {
    const response = await getRequest("/user/getUserStripeDetails");
    if (response.data.success) {
      dispatch({
        type: USER_STRIPE_DATA_SUCCESS,
        payload: response.data,
      });
    } else {
      dispatch({
        type: USER_STRIPE_DATA_FAIL,
        payload: {
          error: response.data.message || "Failed to fetch stripe data",
        },
      });
    }
  } catch (error) {
    console.log(error);
  }
};

// [[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[[]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]

export const uploadFontToS3 = (file) => async (dispatch) => {
  const formData = new FormData();
  formData.append("font", file);
  const response = await postRequest("/project/fonts/upload", formData);
  if (response?.data?.success) {
    // Re-fetch full list so Redux has all fonts including the new one
    const listResponse = await getRequest("/project/fonts/user");
    if (listResponse?.data?.success) {
      dispatch({
        type: CUSTOM_FONTS_LOAD_SUCCESS,
        payload: { fonts: listResponse.data.fonts },
      });
    }
  }
  return response?.data;
};

export const fetchUserFonts = () => async (dispatch) => {
  const response = await getRequest("/project/fonts/user");
  if (response?.data?.success) {
    dispatch({
      type: CUSTOM_FONTS_LOAD_SUCCESS,
      payload: { fonts: response.data.fonts },
    });
  }
  return response?.data;
};

export const deleteUserFont = (font) => async (dispatch, getState) => {
  try {
    const response = await deleteRequest("/project/deleteFont", { key: font.key });
    if (response?.data?.success) {
      toast(
        <CustomToast
          title=""
          content={"Font deleted successfully !"}
        />,
        customToatStyle
      );

      // Handle fallback for currently applied styles
      const state = getState();
      const fontStyle = state.project?.fontStyle;
      const isCard = state.project?.isCard;
      const deletedFontFamily = font.fontFamily;
      const fallbackFont = "archivo narrow";

      if (fontStyle) {
        for (const [styleKey, styleValue] of Object.entries(fontStyle)) {
          if (styleValue && styleValue.fontFamily === deletedFontFamily) {
            // Update Redux state locally
            await dispatch(updateFontStyleState(styleKey, "fontFamily", fallbackFont, styleKey));

            // Save updated block to the backend
            await dispatch(saveFontStyle(styleKey, styleKey, "fontFamily", fallbackFont, null, isCard));
          }
        }
      }

      dispatch(fetchUserFonts()); // Refetch fonts after deletion
    } else {
      toast(
        <CustomToast
          title=""
          content={response?.data?.error || "Failed to delete font"}
        />,
        customToatStyle
      );
    }
    return response?.data;
  } catch (error) {
    console.error("Error deleting font:", error);
    toast(
      <CustomToast
        title=""
        content={"Failed to delete font"}
      />,
      customToatStyle
    );
    return { success: false, error: error.message };
  }
};
